import { render, staticRenderFns } from "./ConfirmLiveChatInvitation.vue?vue&type=template&id=65e9af04&"
import script from "./ConfirmLiveChatInvitation.vue?vue&type=script&lang=ts&"
export * from "./ConfirmLiveChatInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports